import { logger } from '../../util/logger';

export const createOnError = (evid, params) => (error: Error) => {
  logger.log({
    error,
    message: `Fail to send bi event. Evid:${evid}`,
    callParams: params,
  });
};
